export default __webpack_public_path__ + "static/media/logo-icon.6d9b499d.svg";